<template>
  <ion-page>
    <ion-header>
      <AppHeader />
    </ion-header>
    <Loading class="w-full mx-auto" v-if="isLoadingWhitelist" />
    <ion-content
      v-else-if="resource"
      :id="id"
      fullscreen="false"
      class="master"
      :class="{ 'master-ios': isIos(), 'master-android': isAndroid() }"
      :scroll-events="enableScrollEvent"
    >
      <main
        class="lg:flex h-100vh lg:h-auto background-img"
        :style="{ '--fd-background': `url(${REMOTE_ASSETS.fdBackground})` }"
      >
        <SideBar class="shrink-0" @open-modal="toggleLogoutPopup()" />
        <slot class="flex-1 page-bottom-padding" test="test"> </slot>
      </main>
    </ion-content>
    <div
      v-else
      class="password-background-img"
      :style="{ '--fd-background': `url(${REMOTE_ASSETS.fdBackground})` }"
    >
      <PasswordEntry
        class="mt-[112px] h-[calc(100vh-180px)] lg:h-[100vh] w-[248px]"
        :is-loading="isLoadingPassword"
        :res-status="resStatus"
        :button-text="buttonText"
        @enter-password="getResourceWithPassword"
      />
    </div>
  </ion-page>
</template>
<script>
import { REMOTE_ASSETS } from '@/constants/REMOTE_ASSETS';
import { IonPage, IonHeader, IonContent, IonToolbar, isPlatform } from '@ionic/vue';
import { mapState } from 'vuex';
import SideBar from '../components/common/Sidebar.vue';
import AppHeader from '../components/common/Header.vue';
import ButtonsCard from '@/components/HomePage/ButtonsCard.vue';
import { isIosNativeOnly, isAndroidNativeOnly } from '@/utils/platform-check';
import Loading from '@/components/common/LoadingState.vue';
import PasswordEntry from '@/components/ProtectedPage/PasswordEntry';
import axios from 'axios';
import { lockToPortrait } from '@/utils/screen-orientation';

export default {
  components: {
    IonPage,
    IonHeader,
    IonContent,
    IonToolbar,
    SideBar,
    AppHeader,
    ButtonsCard,
    Loading,
    PasswordEntry,
  },
  props: {
    pageTitle: {
      type: String,
      default: '',
    },
    enableScrollEvent: {
      type: Boolean,
      default: false,
    },
    noLogin: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: 'ion-content',
    },
    showFooter: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      REMOTE_ASSETS,
      showLogoutPopup: false,
      showPhotoPopup: false,
      showExpModal: false,
      selectedExp: null,
      showExpButton: false,
      windowWidth: null,
      isLoadingPassword: false,
      isLoadingWhitelist: true,
      resource: undefined,
      resStatus: 0,
      buttonText: 'Access Letters',
      slug: '',
      routeName: '',
    };
  },
  computed: {
    ...mapState('user', ['token']),
  },
  async mounted() {
    await lockToPortrait();
    if (!this.noLogin) {
      // await StatusBar.setOverlaysWebView({ overlay: true });
      /**
       * Parallelising the api,
       * as they are not inter-dependent of one another,
       * don't need to use await
       * */
      await Promise.all([
        this.$store.dispatch('profile/fetchProfile'),
        this.$store.dispatch('lookups/fetchProfileDropdowns'),
        this.$store.dispatch('lookups/fetchPastoralMapping'),
      ]);
      try {
        this.routeName = this.$route.path.substring(1, this.$route.path.length);
        if (this.routeName.includes('/')) {
          this.slug = this.routeName.replace('/', '-');
          // just check if whitelisted, no data needed
          await axios.get(process.env.VUE_APP_API_URL + `/cms/protected/${this.slug}/whitelist`, {
            headers: {
              Authorization: `Bearer ${this.token}`,
            },
          });
        }
        // check whitelisted for main resource
        const response = await axios.get(
          process.env.VUE_APP_API_URL + '/cms/protected/hogcfd/whitelist',
          {
            headers: {
              Authorization: `Bearer ${this.token}`,
            },
          },
        );
        this.resource = response.data;
      } catch (e) {
        if (e.response && (e.response.status === 403 || e.response.status === 500)) {
          this.$router.push({ path: '/' });
        }
      } finally {
        this.$store.dispatch('protected/updateCurrResource', this.resource);
        this.isLoadingWhitelist = false;
      }
    }
  },
  async beforeUnmount() {
    await lockToPortrait();
  },
  methods: {
    isIos() {
      return isIosNativeOnly();
    },
    isAndroid() {
      return isAndroidNativeOnly();
    },
    async getResourceWithPassword(password) {
      if (this.isLoadingPassword) return;
      this.isLoadingPassword = true;
      try {
        console.log('in getResourceWithPassword');
        console.log(this.routeName);
        if (this.routeName.includes('/')) {
          console.log('in IF Statement');
          this.slug = this.routeName.replace('/', '-');
          // just check if password is correct, no data needed
          await axios.post(process.env.VUE_APP_API_URL + '/cms/protected', {
            method: 'post',
            data: { password, slug: this.slug },
            headers: {
              Authorization: `Bearer ${this.token}`,
            },
          });
        }
        console.log('in Outside Statement');
        // check password works for main resource
        const response = await axios.request(process.env.VUE_APP_API_URL + '/cms/protected', {
          method: 'post',
          data: { password, slug: 'hogcfd' },
          headers: {
            Authorization: `Bearer ${this.token}`,
          },
        });
        this.resource = response.data;
        console.log(this.resource);
        this.resStatus = response.status;
        console.log(this.resStatus);
      } catch (e) {
        if (e.response && e.response.status === 401) {
          this.resStatus = e.response.status;
        }
      } finally {
        this.$store.dispatch('protected/updateCurrResource', this.resource);
        this.isLoadingPassword = false;
      }
    },
  },
};
</script>
<style scoped>
ion-footer {
  --border-color: transparent;
  --background: #f2efed;
  --ion-color-base: transparent !important;
}

ion-toolbar {
  --border-color: transparent;
  --background: transparent;
  --ion-color-base: transparent !important;
}

ion-content.master {
  --padding-bottom: 0px;
}

/* iOS-specific offset */
ion-content.master-ios {
  --offset-top: -10% !important;
}

/* Android doesn't need negative offset */
ion-content.master-android {
  --offset-top: 0px !important;
}

.footer-md::before {
  display: none;
}

.box-shadow {
  box-shadow: 0px 1px 25px 0px #0000001a;
}
.background-img {
  background-image: var(--fd-background);
  width: 100vw;
}
.password-background-img {
  background-image: var(--fd-background);
}
</style>
